import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import React from "react";
import { MenuIcon } from "../Menu/Components";
import { TrackingInfo } from "../tracking/TrackingInfoMenu";

export const UserareaSectionContainerItem = props => {
  const { key, linkProps } = props;
  const trackingInfoLocal = TrackingInfo
    ? Object.assign({}, TrackingInfo, { dataLabel: linkProps.name })
    : {
        dataCategory: "default",
        dataAction: "click",
        dataLabel: linkProps.name
      };
  return (
    <li
      key={key}
      className={linkProps.className}
      onClick={linkProps.onClick}
      data-testid={linkProps.dataTestId}
    >
      <a
        href={linkProps.href}
        target={linkProps.target}
        data-category={trackingInfoLocal.dataCategory}
        data-action={trackingInfoLocal.dataAction}
        data-label={trackingInfoLocal.dataLabel}
        data-value=""
      >
        {linkProps.hasIcon && <MenuIcon iconKey={linkProps.iconKey} />}
        <span className="ellipsis-span">
          <FormattedMessage {...linkProps.text} />
        </span>
        {linkProps.descriptionText && (
          <span className="userarea-section-links-description">
            <FormattedMessage {...linkProps.descriptionText} />
          </span>
        )}
      </a>
    </li>
  );
};

UserareaSectionContainerItem.propTypes = {
  linkProps: PropTypes.array,
  trackingInfo: PropTypes.object,
  key: PropTypes.number
};
